import Observable from "zen-observable"
import client from "@irati/utils/services/apollo"
import AuthStorage from "@irati/auth/streams/auth/storage"
import AuthServiceAbstract from "@irati/auth/streams/auth/base"
import tokens from "@irati/auth/services/tokens"
import MerchantAuth from "../../types/MerchantAuth"
import resumeMerchantQuery from "../../services/query/resume"

class MerchantAuthStream extends AuthServiceAbstract<MerchantAuth> {
  private _hasRequestTokens = false

  start(data: MerchantAuth) {
    return super.start(data)
  }

  isValid(auth: MerchantAuth) {
    return !!(auth.productPermissions && auth.user)
  }

  async init() {
    const data = await this.storage.get()
    if (!this._hasRequestTokens) {
      this._hasRequestTokens = true
      await tokens.resume()
    }

    if (data && data.user) {
      return this.start(data)
    }
  }

  protected query(initialData: MerchantAuth) {
    return async() =>
      new Observable<{data: MerchantAuth}>((observer) => {
        client.watchQuery<MerchantAuth>({query: resumeMerchantQuery}).subscribe(
          (authData) => {
            observer.next({data: {...authData.data, user: initialData.user}})
          },
          (err) => observer.error(err),
          () => observer.complete()
        )
      })
  }
}

export default new MerchantAuthStream({storage: new AuthStorage("merchant")})
